import React from 'react';
import { Col, Input, Row } from 'antd';
import type { ChangeEvent } from 'react';

const { TextArea } = Input;

interface ShipmentCommentBoxProps {
  onTextareaChange?: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  error?: boolean;
  mb?: string;
  height?: string;
  placeholder?: string;
}

const ShipmentCommentBox: React.FC<ShipmentCommentBoxProps> = ({
  onTextareaChange,
  error,
  mb = '20px',
  height = '100px',
  placeholder = 'Add comment',
}) => {
  return (
    <Row style={{ marginBottom: mb }}>
      <Col span={24}>
        <TextArea
          maxLength={500}
          onChange={onTextareaChange}
          placeholder={placeholder}
          style={{
            height: height,
            border: '10px solid #F3F3F3',
            background: 'var(--light-gray)',
          }}
        />
        {error && (
          <p
            style={{
              color: 'var(--danger)',
              marginBottom: '0px',
              fontSize: '10px',
              marginTop: '2px',
            }}
          >
            Please give your valuable comments
          </p>
        )}
      </Col>
    </Row>
  );
};

export default ShipmentCommentBox;
